import { render, staticRenderFns } from "./Tabbars.vue?vue&type=template&id=72831a3d"
import script from "./Tabbars.vue?vue&type=script&lang=js"
export * from "./Tabbars.vue?vue&type=script&lang=js"
import style0 from "./Tabbars.vue?vue&type=style&index=0&id=72831a3d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports